import { Component } from '@angular/core';

@Component({
  selector: 'ai-summary-loading',
  templateUrl: './ai-summary-loading.component.html',
  styleUrl: './ai-summary-loading.component.scss'
})
export class AiSummaryLoadingComponent {}
